import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { AnoSafra } from 'src/app/classes/AnoSafra'
import { NgForm, NgModel } from '@angular/forms'
import { UiModalComponent } from 'src/app/theme/shared/components/modal/ui-modal/ui-modal.component'
import { UtilsService } from 'src/app/utils/utils.service'
import { AnoSafraService } from 'src/app/services/ano-safra.service'
import { StorageService } from 'src/app/services/storage.service'
import Swal from 'sweetalert2'

@Component({
  selector: 'app-forms-ano-safra',
  templateUrl: './forms-ano-safra.component.html',
  styleUrls: ['./forms-ano-safra.component.scss'],
})
export class FormsAnoSafraComponent implements OnInit {
  @ViewChild('Modal', { static: false })
  modal: UiModalComponent
  @Output() finalizarSave: EventEmitter<AnoSafra> = new EventEmitter()
  @Output() abrirModalCultura: EventEmitter<void> = new EventEmitter()
  @Output() onExcluirAnoSafra: EventEmitter<boolean> = new EventEmitter()
  @Output() onOperacaoAnoSafra: EventEmitter<boolean> = new EventEmitter()
  isSubmit: boolean = false
  anoSafra: AnoSafra = new AnoSafra()
  carregando: boolean = false

  constructor(
    private utils: UtilsService,
    private anoSafraService: AnoSafraService,
    private storageService: StorageService,
  ) {}

  ngOnInit() {}

  abrirModal(anoSafra: AnoSafra = null): void {
    if((anoSafra == null && !this.utils.verificarPermissaoUsuario('IncluirAnoSafra'))
      || anoSafra != null && !this.utils.verificarPermissaoUsuario('EditarAnoSafra'))
      return;
    if (anoSafra != null) this.anoSafra = anoSafra
    else this.anoSafra = new AnoSafra()
    this.modal.show()
  }

  fecharModal(): void {
    this.modal.hide()
    this.isSubmit = false
  }

  isCampoInvalido(campo: NgModel): boolean {
    return (
      !campo.valid &&
      (campo.dirty || campo.touched || (campo.errors && campo.errors.pattern) || this.isSubmit)
);
  }

  save(form: NgForm): void {
    console.debug(this.anoSafra)
    this.carregando = true
    this.onOperacaoAnoSafra.emit(true)

    if (!this.validarForm(form)) return

    if (this.anoSafra.Id) {
      this.atribuirFazendaSeNaoTiver()
      this.anoSafraService
        .putAnoSafra(this.anoSafra.Id, this.anoSafra)
        .subscribe(
          (res) => {
            this.finalizarSaveRequestSuccess(
              'Ano de safra alterado com sucesso!',
            )
          },
          (err) => {
            this.finalizarRequestError(err)
          },
        )
    } else {
      this.anoSafraService.postAnoSafraFazenda(this.anoSafra).subscribe(
        (res) => {
          this.finalizarSaveRequestSuccess(
            'Ano de safra cadastrado com sucesso!',
          )
          //this.exibirAlertRedirectCultura()
        },
        (err) => {
          this.finalizarRequestError(err)
        },
      )
    }
  }

    confirmExcluirCultura(noSafra: AnoSafra): void{
      if(!this.utils.verificarPermissaoUsuario('ExcluirAnoSafra'))
        return;
      Swal.fire({
        title: 'Você tem certeza desta ação?',
        text:
          'Deseja excluir este Ano de Safra?. Essa ação é irreversível!',
        type: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Excluir Ano Safra',
      }).then((response) => {
        if (!response.dismiss) {
          //this.validaExcluirCultura(cultura)
          this.excluir(noSafra)
        }
      })
    }

  excluir(anoSafra: AnoSafra): void{
    this.carregando = true;
    this.onExcluirAnoSafra.emit(true);
    this.onOperacaoAnoSafra.emit(true);
    
    this.anoSafraService.deleteAnoSafra(anoSafra.Id).subscribe(
      res => {
        this.utils.handleSuccess("Ano de safra excluído com sucesso!")
        this.carregando = false;
        this.onOperacaoAnoSafra.emit(false);
        this.finalizarSave.emit(null)
      },
      err => {
        this.utils.getErro(err)
        this.carregando = false;
        this.onExcluirAnoSafra.emit(false);
        this.onOperacaoAnoSafra.emit(false);
      }
    )
  }

  atribuirFazendaSeNaoTiver(): void {
    if (!this.anoSafra.FazendaId) {
      var fazenda = this.storageService.getFazenda()
      this.anoSafra.FazendaId = fazenda.Id
    }
  }

  validarForm(form: NgForm): boolean {
    if (form.invalid) {
      this.isSubmit = true
      this.carregando = false
      this.utils.handleWarning(
        'Por favor, preencha todos os campos obrigatórios corretamente.',
      )
      return false
    }

    return true
  }

  exibirAlertRedirectCultura(): void {
    Swal.fire({
      title: 'Próximos Passos',
      text:
        'O seu Ano Safra foi criado com Sucesso! Agora, você pode partir para o cadastro da primeira Cultura em seu Ano Safra. Para isso clique em “Inserir Cultura”.',
      type: 'success',
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: 'Deixar pra depois',
      confirmButtonText: 'Inserir cultura',
    }).then((response) => {
      if (!response.dismiss) {
        this.abrirModalCultura.emit()
      }
    })
  }

  finalizarSaveRequestSuccess(msg: string): void {
    this.utils.handleSuccess(msg)
    this.carregando = false
    this.finalizarSave.emit(this.anoSafra)
    this.fecharModal()
  }

  finalizarRequestError(error: any): void {
    this.utils.getErro(error)
    this.carregando = false
    this.onOperacaoAnoSafra.emit(false)
  }
}
